import { Component, computed, effect, input, signal } from '@angular/core';

@Component({
  selector: 'app-filtered-auction-timer',
  imports: [],
  templateUrl: './filtered-auction-timer.component.html',
  styleUrl: './filtered-auction-timer.component.scss',
})
export class FilteredAuctionTimerComponent {
  secondsLeft = input<number>(0);
  separator = input<string>(':');
  startTimerFlag = input<boolean>(false);

  private remaining = signal(0);
  private timerId: any = null;

  private _react = effect(() => {
    const init = Math.max(0, Math.floor(this.secondsLeft() ?? 0));
    this.stopTimer();
    this.remaining.set(init);
    if (this.startTimerFlag() && init > 0) {
      this.startTimer();
    }
  });

  displaySeconds = computed(() => this.remaining());

  timeUnits = computed(() => {
    const total = this.displaySeconds();
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;

    return [
      {
        value: pad(minutes),
        raw: minutes,
        label: this.pluralize(minutes, ['minuta', 'minuty', 'minut']),
      },
      {
        value: pad(seconds),
        raw: seconds,
        label: this.pluralize(seconds, ['sekunda', 'sekundy', 'sekund']),
      },
    ];
  });

  private startTimer() {
    this.timerId = setInterval(() => {
      const next = Math.max(0, this.remaining() - 1);
      this.remaining.set(next);
      if (next === 0) this.stopTimer();
    }, 1000);
  }

  private stopTimer() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  private pluralize(value: number, forms: [string, string, string]): string {
    if (value === 1) return forms[0];
    if (
      value % 10 >= 2 &&
      value % 10 <= 4 &&
      (value % 100 < 10 || value % 100 >= 20)
    ) {
      return forms[1];
    }
    return forms[2];
  }

  ngOnDestroy() {
    this.stopTimer();
  }
}
